export default "__VITE_PUBLIC_ASSET__c38a5eb5__"